import { render, staticRenderFns } from "./UiGallery.vue?vue&type=template&id=e8d48cd0&lang=pug&"
import script from "./UiGallery.vue?vue&type=script&lang=ts&"
export * from "./UiGallery.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports